import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddEnrolmentComponent } from './add-enrolment/add-enrolment.component';
import { EditEnrolmentComponent } from './edit-enrolment/edit-enrolment.component';
import { EnrolmentListComponent } from './enrolment-list/enrolment-list.component';
import { EnrolmentViewComponent } from './enrolment-view/enrolment-view.component';
import { NewManageComponent } from './new-manage/new-manage.component';
import { PermissionGuard } from 'app/shared/auth/auth-guard.service';
import { EnrolledStudentFeesComponent } from './enrolled-student-fees/enrolled-student-fees.component';

const routes: Routes = [
  {
    path: '',
    children: [
    {
      path:'enrollment-list' , component:EnrolmentListComponent,
      data: {
        title: 'Enrollments List Page'
      }
      },
    {
      path:'enrollment-pending-list' , component:EnrolmentListComponent,
      data: {
        title: 'Enrollments List Page'
      }
      },
    {
      path:'enrollment-classroom-list' , component:EnrolmentListComponent,
      data: {
        title: 'Enrollments List Page'
      }
      },
    {
      path:'enrollment-online-list' , component:EnrolmentListComponent,
      data: {
        title: 'Enrollments List Page'
      }
    },
    {
      path:'enrollment-completed-list' , component:EnrolmentListComponent,
      data: {
        title: 'Enrollments List Page'
      }
    },
    {
      path:'enrollment-create' , component:AddEnrolmentComponent,
      data: {
        title: 'Enrollment Create Page'
      }
    },
    {
      path:'enrollment-list-student-fees-manage' , component:EnrolledStudentFeesComponent,
      data: {
        title: 'Enrollments List Page'
      }
    },
    {
      path:'enrollment-edit/:id' , component:EditEnrolmentComponent,
      data: {
        title: 'Enrollment Edit Page'
      }
    },
    {
      path:'edit/:id' , component:EditEnrolmentComponent,
      data: {
        title: 'Enrollment Edit Page'
      }
    },
    {
      path:'enrollment-view/:id' , component:EnrolmentViewComponent,
      canActivate: [PermissionGuard],
      data: { roles: ['admin','Managment','HR'] } 
    },
    {
      path:'enrollment-report/:id' , component:NewManageComponent,
      data: {
        title: 'Enrollment Report'
      }
    },
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EnrolmentRoutingModule { }
